  <mm-text-input-control [parentForm]="parentForm" [inputControlModel]="commentInputModel"></mm-text-input-control>
  <div *ngIf="warningData" id="warning">
    <div id="warning-icon" data-testid="warning-icon" class="warning-icon-comment"></div>
    <span id="warning-text">Do not include personal non-public information.</span>
  </div>
